<script>
/**
 * Salesperson Bar Chart Component
 * Bar chart for comparing salesperson performance
 */
import { Bar } from 'vue-chartjs';

export default {
  name: 'SalespersonChart',
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: () => ({ labels: [], datasets: [] })
    },
    height: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'top',
          labels: {
            fontFamily: "'Source Sans Pro', sans-serif",
            fontSize: 12,
            usePointStyle: true,
            padding: 15
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          titleFontFamily: "'Source Sans Pro', sans-serif",
          bodyFontFamily: "'Source Sans Pro', sans-serif",
          callbacks: {
            label: (tooltipItem, data) => {
              const label = data.datasets[tooltipItem.datasetIndex].label || '';
              const value = tooltipItem.yLabel;
              return `${label}: ${this.formatCurrency(value)}`;
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            gridLines: {
              display: false
            },
            ticks: {
              fontFamily: "'Source Sans Pro', sans-serif",
              fontSize: 11,
              fontColor: '#5A6467',
              maxRotation: 45,
              minRotation: 45
            }
          }],
          yAxes: [{
            display: true,
            gridLines: {
              color: 'rgba(0, 0, 0, 0.05)',
              drawBorder: false
            },
            ticks: {
              fontFamily: "'Source Sans Pro', sans-serif",
              fontSize: 11,
              fontColor: '#5A6467',
              callback: (value) => this.formatCurrency(value, true),
              beginAtZero: true
            }
          }]
        }
      }
    };
  },
  watch: {
    chartData: {
      handler() {
        this.renderBarChart();
      },
      deep: true
    }
  },
  mounted() {
    this.renderBarChart();
  },
  methods: {
    renderBarChart() {
      if (!this.chartData || !this.chartData.labels || this.chartData.labels.length === 0) return;
      
      this.renderChart(this.chartData, this.options);
    },
    formatCurrency(value, compact = false) {
      if (compact) {
        if (Math.abs(value) >= 1000000) {
          return `${(value / 1000000).toFixed(1)}M kr`;
        }
        if (Math.abs(value) >= 1000) {
          return `${(value / 1000).toFixed(0)}k kr`;
        }
      }
      return `${value.toLocaleString('sv-SE')} kr`;
    }
  }
};
</script>

<style scoped>
</style>
